import {type IBrandPortal} from '../schema';
import {getCurrentPortal} from './getCurrentPortal';

export const getCurrentPortalProp = (key: keyof IBrandPortal) =>
	getCurrentPortal()?.[key];
